module.exports = {"deleteLink":"Remove myself as guardian","meta":"I am a guardian"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/proteges.json
// module id = i+Rl
// module chunks = 1